// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");

let El = {};

function computeHasOverflow(el) {
  let oh = el.offsetHeight;
  let sh = el.scrollHeight;
  let ow = el.offsetWidth;
  let sw = el.scrollWidth;
  if (oh < sh) {
    return true;
  } else {
    return ow < sw;
  }
}

function Text__Jsx3$WithOverflowV5(props) {
  let children = props.children;
  let hasOverflowCallback = props.hasOverflowCallback;
  let lineClamp = props.lineClamp;
  let __as_ = props.as_;
  let as_ = __as_ !== undefined ? __as_ : "span";
  let elementRef = React.useRef(null);
  React.useEffect(() => {
    let match = elementRef.current;
    if (hasOverflowCallback === undefined) {
      return;
    }
    if (match == null) {
      return;
    }
    hasOverflowCallback(computeHasOverflow(match));
    let handler = _event => hasOverflowCallback(computeHasOverflow(match));
    window.addEventListener("resize", handler);
    return () => {
      window.removeEventListener("resize", handler);
    };
  }, [hasOverflowCallback]);
  let baseClampClasses = lineClamp !== undefined ? "overflow-hidden" : "";
  let finalClassName = Stdlib_Option.getOr(Stdlib_Option.map(props.className, c => TailwindMerge.twMerge([
    baseClampClasses,
    c
  ])), baseClampClasses);
  let style = lineClamp !== undefined ? ({
      display: "-webkit-box",
      WebkitLineClamp: lineClamp.toString(),
      WebkitBoxOrient: "vertical",
      wordBreak: "break-word"
    }) : undefined;
  if (as_ === "div") {
    return JsxRuntime.jsx("div", {
      children: children,
      ref: Primitive_option.some(elementRef),
      className: finalClassName,
      style: style
    });
  } else {
    return JsxRuntime.jsx("span", {
      children: children,
      ref: Primitive_option.some(elementRef),
      className: finalClassName,
      style: style
    });
  }
}

let WithOverflowV5 = {
  El: El,
  computeHasOverflow: computeHasOverflow,
  make: Text__Jsx3$WithOverflowV5
};

exports.WithOverflowV5 = WithOverflowV5;
/* react Not a pure module */
